import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import styles from './ClockDateAndDay.module.scss'

export const ClockDateAndDay: React.FC = () => {
  const { i18n } = useTranslation()
  const [now, setNow] = useState<Date>(() => new Date())

  useEffect(() => {
    const updateNow = () => setNow(new Date())

    let intervalId: ReturnType<typeof setInterval> | null = null
    const msUntilNextMinute = 60000 - (Date.now() % 60000)

    const timeoutId = setTimeout(() => {
      updateNow()
      intervalId = setInterval(updateNow, 60000)
    }, msUntilNextMinute)

    return () => {
      clearTimeout(timeoutId)
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [])

  const currentLocale = i18n?.resolvedLanguage

  return (
    <div className={styles.currentDate}>
      <div className={styles.currentDateDay}>
        <p className={styles.currentMonth}>
          {now.toLocaleDateString(currentLocale, {
            month: 'long'
          })}
        </p>
        <p className={styles.currentDay}>
          {now.toLocaleDateString(currentLocale, {
            weekday: 'long'
          })}
        </p>
      </div>
      <p className={styles.currentDateValue}>
        {now.toLocaleDateString(currentLocale, {
          day: '2-digit'
        })}
      </p>
    </div>
  )
}
